$('.sticky-sidebar').theiaStickySidebar({
	// Settings
	additionalMarginTop: 96,
	containerSelector: '.sticky-container'
});